import { useEffect } from "react";
import { query, where, onSnapshot, Timestamp } from "firebase/firestore";
import { useSelector } from "react-redux";
import useSystemClock from "modules/system/hooks/useSystemClock";
import { selectCurrentEventId } from "modules/event/selectors";
import { selectIsInBroadcast } from "modules/broadcast/redux/selectors";
import { QUERY_CUTOFF_TIME } from "modules/emoji/Reactions/constants";
import { useAppDispatch } from "store/hooks";
import { setCurrentAudio } from "modules/audioReactions/redux/slice";
import { getAudioReactionsRef } from "modules/audioReactions/firestore";
import {
  AudioReactionsTypes,
  AudioReactionsPath,
} from "modules/audioReactions/constants";

export const useAudioReactionsSubscription = () => {
  const { serverTime } = useSystemClock();
  const eventId = useSelector(selectCurrentEventId);
  const isInBroadcast = useSelector(selectIsInBroadcast);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!eventId) return;

    const audioReactionsRef = getAudioReactionsRef(eventId);
    const audioReactionsQuery = query(
      audioReactionsRef,
      where("time", ">", Timestamp.fromMillis(serverTime - QUERY_CUTOFF_TIME)),
    );

    const unsubscribe = onSnapshot(audioReactionsQuery, (snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === "added") {
          if (isInBroadcast) {
            dispatch(
              setCurrentAudio(
                AudioReactionsPath[
                  change.doc
                    .data()
                    .reactionType.toString() as AudioReactionsTypes
                ],
              ),
            );
          }
        }
      });
    });

    // eslint-disable-next-line consistent-return
    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId, isInBroadcast]);
};
